import { isJwtExpired } from '.'
import '../../firebase'
import '../../firebase-admin'
import * as admin from 'firebase-admin'
import { auth } from 'firebase'

/**
 * id tokenの取得 & 生成
 * サーバーサイドのみ
 * firebase-adminはclientでエラーになるので、package.jsonのbrowserにてfalseにする
 *
 */
export default async function getIdToken(req) {
  if (process.browser) return null

  if (!req?.session?.user) {
    return null
  }

  /**
   * id tokenの期限が切れてない場合、セッションのidトークンを利用する
   */
  if (req?.session?.idToken && isJwtExpired(req.session.idToken)) {
    return req.session.idToken
  }

  /**
   * サーバーサイドでは、カスタムトークン生成しないとidトークン発行できない(firebase仕様)
   */
  const customToken = await admin.auth().createCustomToken(req.session.user.uid)
  const userCredential = await auth().signInWithCustomToken(customToken)

  return userCredential.user.getIdToken()
}
